import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom"; 
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const Sidebar = ({ userType }) => {
  const [reviewerNumber, setReviewerNumber] = useState(null);
  const [reviewers, setReviewers] = useState([]);
  const theUserId = localStorage.getItem('userId');
  const theFirstName = localStorage.getItem('theFirstName'); 
  const theLastName = localStorage.getItem('theLastName'); 
  const fullName = theFirstName + " " + theLastName;
  const navigate = useNavigate();

  
  const handleLogout = (e) => {
    e.preventDefault(); 
    localStorage.clear(); 
    navigate('/login');   
  };

  useEffect(() => {
    const fetchReviewers = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/users/reviewers`
        );
        const data = response.data;
  
        const rawList = Array.isArray(data)
          ? data
          : Array.isArray(data.$values)
          ? data.$values
          : [];
  
        const allReviewers = rawList.map((r) => ({
          ...r,
          id: String(r.id),
        }));
        setReviewers(allReviewers);
  
        if (!theUserId) return;
  
        const current = allReviewers.find(
          (r) => r.id === String(theUserId)
        );
        if (current) {
          setReviewerNumber(current.reviewerNumber);
        }
      } catch (error) {
        console.error("Error fetching reviewers:", error);
        setReviewers([]);
      }
    };
  
    fetchReviewers();
  }, [theUserId]);
  

  return (
    <ul className="navbar-nav bg-gradient-primary sidebar sidebar-dark accordion" id="accordionSidebar">
      <a className="sidebar-brand d-flex align-items-center justify-content-center" href="index.html">
        <div id="test">Requisition & Surrender System</div>
      </a>

      <hr className="sidebar-divider my-0" />

      <li className="nav-item active">
        <Link className="nav-link" to="/dashboard">
          <i className="fas fa-fw fa-tachometer-alt"></i>
          <span>Dashboard</span>
        </Link>
      </li>

      <hr className="sidebar-divider" />

      <div className="sidebar-heading">Interface</div>

      {userType === 'Administrator' && (
      <li className="nav-item">
        <Link className="nav-link" to="/add-user">
          <i className="fas fa-fw fa-table"></i>
          <span>Add User</span>
        </Link>
      </li>
        )}

        {userType === 'Administrator' && (
      <li className="nav-item">
        <Link className="nav-link" to="/view-users">
          <i className="fas fa-fw fa-table"></i>
          <span>View Users</span>
        </Link>
      </li>
        )}
        {userType === 'Administrator' && (
      <li className="nav-item">
        <Link className="nav-link" to="/cost-driver-dropdown">
          <i className="fas fa-fw fa-table"></i>
          <span>Cost Driver Dropdown</span>
        </Link>
      </li>
        )}

      {userType === 'Requester' && (
      <li className="nav-item">
        <Link className="nav-link" to="/requisitions">
          <i className="fas fa-fw fa-table"></i>
          <span>Requisitions</span>
        </Link>
      </li>
        )}
        {userType === 'Requester' && (
        <>
          <li className="nav-item">
            <Link className="nav-link" to="/surrenders">
              <i className="fas fa-fw fa-table"></i>
              <span>Surrenders</span>
            </Link>
          </li>
        </>
      )}
     {(reviewerNumber === 1 || reviewerNumber === 2) && (
        <>
          
          <li className="nav-item">
            <Link className="nav-link" to="/requisitions">
              <i className="fas fa-fw fa-table"></i>
              <span>My Requisitions</span>
            </Link>
          </li>
          <li className="nav-item">
            <Link className="nav-link" to="/surrenders">
              <i className="fas fa-fw fa-table"></i>
              <span>My Surrenders</span>
            </Link>
          </li>
          <hr className="sidebar-divider" />
          <li className="nav-item">
            <Link className="nav-link" to="/approved-requisitions-reviewer-view">
              <i className="fas fa-fw fa-table"></i>
              <span>Approved Requisitions</span>
            </Link>
          </li>
          <li className="nav-item">
            <Link className="nav-link" to="/staff-requisitions">
              <i className="fas fa-fw fa-table"></i>
              <span>Staff Requisitions</span>
            </Link>
          </li>
                  
          <li className="nav-item">
            <Link className="nav-link" to="/staff-surrenders">
              <i className="fas fa-fw fa-table"></i>
              <span>Staff Surrenders</span>
            </Link>
          </li>

          <li className="nav-item">
            <Link className="nav-link" to="/staff-surrenders-summary">
              <i className="fas fa-fw fa-table"></i>
              <span>Staff Surrender Summary</span>
            </Link>
          </li>
          
          
        </>
      )}
      
      {reviewerNumber === 3 && (
        <>
          <li className="nav-item">
            <Link className="nav-link" to="/requisitions">
              <i className="fas fa-fw fa-table"></i>
              <span>My Requisitions</span>
            </Link>
          </li>
          <li className="nav-item">
            <Link className="nav-link" to="/surrenders">
              <i className="fas fa-fw fa-table"></i>
              <span>My Surrenders</span>
            </Link>
          </li>
          <hr className="sidebar-divider" />
          <li className="nav-item">
            <Link className="nav-link" to="/approved">
              <i className="fas fa-fw fa-table"></i>
              <span>Approved</span>
            </Link>
          </li>
          <li className="nav-item">
            <Link className="nav-link" to="/staff-requisitions">
              <i className="fas fa-fw fa-table"></i>
              <span>Staff Requisitions</span>
            </Link>
          </li>
          <li className="nav-item">
            <Link className="nav-link" to="/staff-surrenders">
              <i className="fas fa-fw fa-table"></i>
              <span>Staff Surrenders</span>
            </Link>
          </li>
          <li className="nav-item">
            <Link className="nav-link" to="/staff-surrenders-summary">
              <i className="fas fa-fw fa-table"></i>
              <span>Staff Surrender Summary</span>
            </Link>
          </li>
          </>
           )}
           
      {userType === 'Surrender Reviewer' && (
        <>
          <li className="nav-item">
            <Link className="nav-link" to="/requisitions">
              <i className="fas fa-fw fa-table"></i>
              <span>My Requisitions</span>
            </Link>
          </li>
          <li className="nav-item">
            <Link className="nav-link" to="/surrenders">
              <i className="fas fa-fw fa-table"></i>
              <span>My Surrenders</span>
            </Link>
          </li>
          <hr className="sidebar-divider" />
          <li className="nav-item">
            <Link className="nav-link" to="/approved-requisitions">
              <i className="fas fa-fw fa-table"></i>
              <span>Approved Requisitions</span>
            </Link>
          </li>
          <li className="nav-item">
            <Link className="nav-link" to="/staff-requisitions">
              <i className="fas fa-fw fa-table"></i>
              <span>Staff Requisitions</span>
            </Link>
          </li>
          <li className="nav-item">
            <Link className="nav-link" to="/staff-surrenders">
              <i className="fas fa-fw fa-table"></i>
              <span>Staff Surrenders</span>
            </Link>
          </li>
        </>
      
        )}

      <hr className="sidebar-divider" />

      {userType === 'Requester' && 'Reviewer' && 'Surrender Reviewer' && (    

      <div className="sidebar-heading">Reports</div>
      )}
      
      {userType === 'Requester' && 'Reviewer' && 'Surrender Reviewer' && (    
        
        <li className="nav-item">
        <a className="nav-link" href="">
          <i className="fas fa-fw fa-chart-area"></i>
          <span>Monthly Reports</span>
        </a>
      </li>
     )}
    
    
    {userType === 'Requester' && 'Reviewer' && 'Surrender Reviewer' && (    
      <li className="nav-item">
        <a className="nav-link" href="">
          <i className="fas fa-fw fa-chart-area"></i>
          <span>Weekly Reports</span>
        </a>
      </li>
      )}
      {userType === 'Requester' && 'Reviewer' && 'Surrender Reviewer' && (    

      <li className="nav-item">
        <a className="nav-link" href="">
          <i className="fas fa-fw fa-chart-area"></i>
          <span>Timesheet</span>
        </a>
      </li>
    )}

{userType === 'Requester' && 'Reviewer' && 'Surrender Reviewer' && (    
      <hr className="sidebar-divider" />
    )}
      {userType === 'Requester' && 'Reviewer' && 'Surrender Reviewer' && (    

      <div className="sidebar-heading">Plans</div>
    )}
      {userType === 'Requester' && 'Reviewer' && 'Surrender Reviewer' && (    

      <li className="nav-item">
        <a className="nav-link" href="">
          <i className="fas fa-fw fa-chart-area"></i>
          <span>Monthly Plan</span>
        </a>
      </li>
)}
      {userType === 'Requester' && 'Reviewer' && 'Surrender Reviewer' && (    

      
      <li className="nav-item">
        <a className="nav-link" href="">
          <i className="fas fa-fw fa-chart-area"></i>
          <span>Weekly Plan</span>
        </a>
      </li>
)}
      {userType === 'Requester' && 'Reviewer' && 'Surrender Reviewer' && (    

      <li className="nav-item">
        <a className="nav-link" href="">
          <i className="fas fa-fw fa-chart-area"></i>
          <span>Weekly Updates</span>
        </a>
      </li>
    )}

{userType === 'Requester' && 'Reviewer' && 'Surrender Reviewer' && (    

      
      <hr className="sidebar-divider" />
    )}
      <div className="sidebar-heading">Other</div>
      {userType === 'Requester' && 'Reviewer' && 'Surrender Reviewer' && (    

      <li className="nav-item">
        <a
          className="nav-link collapsed"
          href="#"
          data-toggle="collapse"
          data-target="#collapsePages"
          aria-expanded="true"
          aria-controls="collapsePages"
        >
          <i className="fas fa-fw fa-folder"></i>
          <span>Archives</span>
        </a>
        <div id="collapsePages" className="collapse" aria-labelledby="headingPages" data-parent="#accordionSidebar">
          <div className="bg-white py-2 collapse-inner rounded">
            <h6 className="collapse-header">Login Screens:</h6>
            <a className="collapse-item" href="login.html">
              Login
            </a>
            <a className="collapse-item" href="register.html">
              Register
            </a>
            <a className="collapse-item" href="forgot-password.html">
              Forgot Password
            </a>
            <div className="collapse-divider"></div>
            <h6 className="collapse-header">Other Pages:</h6>
            <a className="collapse-item" href="404.html">
              404 Page
            </a>
            <a className="collapse-item" href="blank.html">
              Blank Page
            </a>
          </div>
        </div>
      </li>
       )}
      
      <li className="nav-item">
        <Link className="nav-link" to="/notifications">
          <i className="fas fa-fw fa-cog"></i>
          <span>Notifications</span>
        </Link>
      </li>

      

      <li className="nav-item">
        <Link className="nav-link" to="/settings">
          <i className="fas fa-fw fa-cog"></i>
          <span>Settings</span>
        </Link>
      </li>

      

      

      <li className="nav-item">
        <Link 
          className="nav-link" 
          to="#" 
          onClick={handleLogout}
        >
          <i className="fas fa-sign-out-alt fa-sm fa-fw mr-2 text-gray-400"></i>
          Logout
        </Link>
      </li>

      <hr className="sidebar-divider d-none d-md-block" />

    </ul>
  );
};

export default Sidebar;
